import { t } from "../../../utils/i18n";
import React, { useState } from "react";
import CardSelector from "../CardSelector";

interface Card {
  id: string;
  card_number: string;
  card_type: string;
  status: string;
  first_name: string;
  last_name: string;
}

interface CardLoadsProps {
  cards: Card[];
  initialCardId: string;
  availableBalance: number;
}

export default function CardLoads({
  cards,
  initialCardId,
  availableBalance,
}: CardLoadsProps) {
  const [selectedCardId, setSelectedCardId] = useState(initialCardId);

  const handleCardChange = (cardId: string) => {
    setSelectedCardId(cardId);
    window.location.href = `/cards/${cardId}/card_loads/new`;
  };

  return (
    <div className="container-fluid px-2 px-md-4">
      <div className="card shadow-sm rounded-lg">
        <div className="card-header d-flex flex-column justify-content-center align-items-start">
          <h5 className="create-trade-page-title">
            <i className="fa fa-cart-plus"></i> {t("cards.loads.fund_card")}
          </h5>
          <span>{t("cards.loads.subtitle")}</span>
        </div>
        <div className="card-body">
          <CardSelector
            cards={cards}
            currentCardId={selectedCardId}
            onCardChange={handleCardChange}
          />
        </div>
      </div>
    </div>
  );
}
